<template>
  <div class="app">
    <div class="login">
      <img class="brand_logo" src="../assets/logo.png">
      <div class="login-container">
        <h2>老师评测登录</h2>
        <el-form ref="ruleForm" :model="ruleForm"  :rules="rules">
          <el-form-item class="input" prop="username">
          <el-input id="username" v-model="ruleForm.username" placeholder="手机号或邮箱" @keyup.enter.native="handleEnterKey"></el-input>
          </el-form-item>
          <el-form-item class="input" prop="password">
          <el-input placeholder="请输入密码" id="password"  v-model="ruleForm.password" show-password @keyup.enter.native="handleEnterKey"></el-input>
          </el-form-item>
          <el-form-item class="user">
            <el-checkbox v-model="rememberMe">记住账号</el-checkbox>
            <el-button type="text" @click="handleForgotPassword" class="forgot_pwd">忘记密码？</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="sub" @click="submitForm('ruleForm')">登录</el-button>
          </el-form-item>
        </el-form>
        <p v-if="error" class="error-message">{{ errorMessage }}</p>
      </div>
    </div>
    <div class="bg_round"></div>
  </div>
</template>

<script>
// import {sanDMoxingData} from '../api/app'
import useUserStore from '../stores/modules/user'
import useAppStore from '../stores/modules/app'
// import { merge } from 'lodash'
export default {
  name: 'Login',
  created () {
    this.userStore = useUserStore()
    this.appStore = useAppStore();
  },
  data () {
    return {
      ruleForm: {
        username: '',
        password: ''
      },
      error: false,
      rememberMe: true,
      errorMessage: '',
      userStore: null,
      appStore: null,
      deptId:0,
      rules: {
          username: [
                {
                    required: true,
                    message: '请输入账号',
                    trigger: ['blur']
                }
            ],
            password: [
                {
                    required: true,
                    message: '请输入密码',
                    trigger: ['blur']
                }
            ]
        }
    }
  },
  mounted () {

    this.deptId = this.appStore.getDpId() || this.$route.query.dp;
    if(!this.deptId){
      this.locationBlocked = true;
      this.locationError = "系统入口参数缺失，请联系管理员！";
    }
    console.log('=====this.deptId=====',this.deptId);
  },
  methods: {
    submitForm (formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            // alert('submit!')
            this.handleLogin()
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
    async login () {
    const loginData = await this.userStore.login({...this.ruleForm, main_dept_id: this.deptId})
      // console.log('====登录返回信息=====', loginData)
      // 这里是一个简单的模拟登录验证过程
      if (loginData.token) {
        // 登录成功，可以进行路由跳转或其他操作
        this.$router.push('/student') // 假设有一个名为'dashboard'的路由
        this.error = false
      } else {
        // 登录失败，显示错误信息
        this.error = true
        this.errorMessage = '无效的用户名或密码'
      }
    },
    handleLogin () {
      // 处理登录逻辑
      if (this.rememberMe) {
        this.saveCredentials()
      } else {
        this.clearCredentials()
      }
      // 这里添加登录逻辑，例如 API 调用
      this.login()
      // console.log('登录:', this.ruleForm.username, this.ruleForm.password)
    },
    saveCredentials () {
      localStorage.setItem('username', this.ruleForm.username)
      // localStorage.setItem('password', this.ruleForm.password) // 注意安全隐患
      localStorage.setItem('rememberMe', this.rememberMe)
    },
    loadCredentials () {
      const remembered = localStorage.getItem('rememberMe') === 'true'
      if (remembered) {
        this.ruleForm.username = localStorage.getItem('username') || ''
        this.ruleForm.password = localStorage.getItem('password') || ''
        this.rememberMe = remembered
      }
    },
    clearCredentials () {
      localStorage.removeItem('username')
      localStorage.removeItem('password')
      localStorage.removeItem('rememberMe')
    },
    handleForgotPassword () {
      this.clearCredentials()
      this.$message({
        type: 'info',
        message: '请联系管理员'
      })
      // 在这里可以添加额外的逻辑，例如重定向到重置密码页面
    },
    handleEnterKey () {
      // 回车键触发登录
      this.submitForm('ruleForm')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.brand_logo {
  width: 4rem;
}

.app {
  height: 100vh;
  background: linear-gradient(0deg, #ff9b00, #accd05);
}

.app::before,
.app::after,
.app .bg_round::after {
  content: '';
  height: 0;
  border-radius: 100%;
  position: absolute;
}

.app::before {
  width: 16rem;
  padding-top: 16rem;
  background: rgba(218, 243, 239, 0.13);
  left: -3rem;
  top: -2.2rem;
}

.app::after {
  width: 41.65rem;
  padding-top: 41.65rem;
  background: rgba(218, 243, 239, 0.1);
  right: -20.825rem;
  top: 0;
}

.app .bg_round {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.app .bg_round::after {
  width: 34.2rem;
  padding-top: 34.2rem;
  background: rgba(218, 243, 239, 0.26);
  left: -5rem;
  bottom: -12.5rem;
}

.app .login {
  text-align: center;
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
}

.app > img {
  display: block;
  margin: 0 auto 2rem;
}

.login-container {
  max-width: 39.3rem;
  padding: 3.5rem;
  background: #fff;
  margin: 0 auto;
  border-radius: 1.8rem;
  margin-top: 1.25rem;
  box-sizing: border-box;
  text-align: left;
}

@media (max-width: 780px) {
  .login-container {
    max-width: 90%;
  }
}

.login-container h2 {
  font-size: 1.4rem;
  line-height: 100%;
  margin-bottom: 1rem;
}

.login-container input {
  width: 100%;
  height: 3rem;
  border-radius: 0.35rem;
}

.login-container .input + .input {
  margin-top: 1rem;
}

.login-container .user .el-form-item__content{
  background: #f00;
}

.login-container .input .el-input__inner {
  border: 1px solid #9a9a9a;
}

.login-container .user >>> .el-form-item__content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 100%;
  height: auto;
}

.login-container .user >>> .el-form-item__content::before,
.login-container .user >>> .el-form-item__content::after {
  display: none;
}
.login-container .user >>> .el-form-item__content .el-checkbox__label{
  font-size: 1rem;
  color: #333;
}
.login-container .forgot_pwd {
  font-size: 0.9rem;
  line-height: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
  text-align: right;
  padding: 0;
  margin: 0;
}
.login-container >>> .el-form-item__content .forgot_pwd span{
  font-size: 1rem;
  color: #666;
}
.login-container .sub {
  width: 100%;
  height: 3rem;
  border-radius: 0.35rem;
  border: 0;
  background: linear-gradient(0deg, #ff7200, #ff9c00);
  font-size: 1rem;
  color: #fff;
  cursor: pointer;
}

.error-message {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue